import React from 'react';

import DatePicker from 'components/DatePicker';
import Snackbar from 'components/DesignSystem/Snackbar';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import useNewPastSimulation from 'utils/hooks/flux/automatic/useNewPastSimulation';
import useNewPastSimulationOptions from 'utils/hooks/flux/automatic/useNewPastSimulationOptions';

import './index.scss';

// Mesmos 4 campos do formulário desktop (PastSimulations/New/Form), sem os acordeões
// aninhados — dentro de um sheet eles empilhariam um terceiro nível de expansão.
export default function NewForm({ close }: { close: () => void }) {
  const {
    forecastDate,
    setForecastDate,
    acomphDate,
    setAcomphDate,
    setModel,
    version,
    setVersion,
    submit,
    enablePastSimulationAddition,
  } = useNewPastSimulation(close);

  const {
    filterAcomphDates, filterForecastDates, versions, models, openToForecastDate,
  } = useNewPastSimulationOptions({ acomphDate, forecastDate, version });

  const pick = (setter: (event: React.ChangeEvent<HTMLInputElement>) => void, value: string) => {
    setter({ target: { value } } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className="flux-automatic-new-past-simulation">
      <p className="flux-automatic-new-past-simulation-label">Data da ACOMPH</p>
      <DatePicker
        inline
        selected={acomphDate}
        onChange={setAcomphDate}
        filterDate={filterAcomphDates}
      />

      <p className="flux-automatic-new-past-simulation-label">Data da Simulação</p>
      {!acomphDate && <Snackbar className="mt-2">Selecione a data da ACOMPH primeiro.</Snackbar>}
      {acomphDate && (
        <DatePicker
          inline
          selected={forecastDate}
          onChange={setForecastDate}
          filterDate={filterForecastDates}
          openToDate={openToForecastDate}
        />
      )}

      <p className="flux-automatic-new-past-simulation-label">Modelo</p>
      {models.length === 0 && <Snackbar className="mt-2">Nenhum modelo disponível.</Snackbar>}
      {models.map((model) => (
        <OptionRow
          key={model}
          label={model}
          selected={false}
          onSelect={() => pick(setModel, model)}
        />
      ))}

      <p className="flux-automatic-new-past-simulation-label">Versão</p>
      {versions.length === 0 && <Snackbar className="mt-2">Nenhuma versão disponível.</Snackbar>}
      {versions.map((option) => (
        <OptionRow
          key={option}
          label={option}
          selected={option === version}
          onSelect={() => pick(setVersion, option)}
        />
      ))}

      <div className="flux-automatic-new-past-simulation-actions">
        <SheetActionButton variant="secondary" onClick={close}>
          Cancelar
        </SheetActionButton>
        <SheetActionButton
          variant="confirm"
          onClick={submit}
          disabled={!enablePastSimulationAddition}
        >
          Incluir Simulação
        </SheetActionButton>
      </div>
    </div>
  );
}
